/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailVerification
 */
export interface EmailVerification {
    /**
     * 
     * @type {string}
     * @memberof EmailVerification
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof EmailVerification
     */
    code: string;
}

/**
 * Check if a given object implements the EmailVerification interface.
 */
export function instanceOfEmailVerification(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

export function EmailVerificationFromJSON(json: any): EmailVerification {
    return EmailVerificationFromJSONTyped(json, false);
}

export function EmailVerificationFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailVerification {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': json['email'],
        'code': json['code'],
    };
}

export function EmailVerificationToJSON(value?: EmailVerification | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'code': value.code,
    };
}

